import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserSettingsQuery } from '@examdojo/user-settings';
import { filter, switchMap } from 'rxjs';
import { StreakService } from '@examdojo/streak';

@Injectable()
export class FetchStreaksOnTimezoneChangeService {
  constructor(
    private readonly streakService: StreakService,
    private readonly userSettingsQuery: UserSettingsQuery,
  ) {
    this.userSettingsQuery.timezone$
      .pipe(
        filter(Boolean),
        switchMap(() => this.streakService.fetchStreaks()),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
